module.exports = __webpack_public_path__ + "static/media/phone-3@2x.26555eed.png";